export const messages = {
  page: {
    title: {
      id: 'followUpPlan.Title',
      defaultMessage: 'Follow-up Plan',
    },
    zeroState: {
      id: 'followUpPlan.Page.ZeroState',
      defaultMessage: 'No items to display',
    },
  },
  planDetails: {
    template: {
      id: 'followUpPlan.PlanDetails.Template',
      defaultMessage: '{ templateDisplayName } (effective date: { displayEffectiveDate })',
    },
    title: {
      id: 'followUpPlan.PlanDetails.Title',
      defaultMessage: 'Follow-up Plan Details',
    },
    startDate: {
      id: 'followUpPlan.PlanDetails.StartDate',
      defaultMessage: 'Start Date:',
    },
    instructions: {
      id: 'followUpPlan.PlanDetails.Instructions',
      defaultMessage: 'Instructions:',
    },
    guidelines: {
      id: 'followUpPlan.PlanDetails.Guidelines',
      defaultMessage: 'Guidelines:',
    },
    details: {
      id: 'followUpPlan.PlanDetails.Details',
      defaultMessage: 'Details',
    },
  },
  filter: {
    all: {
      id: 'followUpPlan.Filter.All',
      defaultMessage: 'All',
    },
    upcoming: {
      id: 'followUpPlan.Filter.Upcoming',
      defaultMessage: 'Upcoming',
    },
  },
  columns: {
    label: {
      id: 'followUpPlan.Columns.Label',
      defaultMessage: 'Follow-up',
    },
    date: {
      id: 'followUpPlan.Columns.Date',
      defaultMessage: 'Date',
    },
    provider: {
      id: 'followUpPlan.Columns.Provider',
      defaultMessage: 'Care Provider',
    },
  },
  statements: {
    preference: {
      id: 'followUpPlan.Statements.Preference',
      defaultMessage: 'Notification Settings: {patientNotifPref}',
    },
    timezone: {
      id: 'followUpPlan.Statements.Timezone',
      defaultMessage: 'Follow-up time is shown in {facilityTimeZone} unless otherwise specified.',
    },
  },
  status: {
    scheduled: {
      id: 'followUpPlan.Status.Scheduled',
      defaultMessage: 'Scheduled',
    },
    recommended: {
      id: 'followUpPlan.Status.Recommended',
      defaultMessage: 'Recommended',
    },
    overdue: {
      id: 'followUpPlan.Status.Overdue',
      defaultMessage: 'Overdue',
    },
    completed: {
      id: 'followUpPlan.Status.Completed',
      defaultMessage: 'Completed',
    },
    missed: {
      id: 'followUpPlan.Status.Missed',
      defaultMessage: 'Missed',
    },
    notApplicable: {
      id: 'followUpPlan.Status.NotApplicable',
      defaultMessage: 'N/A',
    },
  },
  notifPreference: {
    FieldName: {
      id: 'followUpPlan.Preference.FieldName',
      defaultMessage: 'follow-up date',
    },
  },
};
